// extracted by mini-css-extract-plugin
module.exports = {"left-column":"_1b7Z9","left-column__content":"_2zfsC","left-column__footer":"_1zVu_","left-column__logo":"YAfCX"};